import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Link from 'next/link';

import Layout from '@/components/layout';

export default function FAQ() {
    return (
        <Layout title="FAQ">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10 col-xl-8">

                        {/* <!-- Header --> */}
                        <div className="header mt-md-5">
                            <div className="header-body">

                                {/* <!-- Title --> */}
                                <h1 className="header-title display-4">
                                    FAQ
                                </h1>

                            </div>
                        </div>

                        <h3>Was ist HYAPP?</h3>
                        <p>
                            HYAPP ist eine integrierte Datenplattform, auf der Sie Controlling- und Workflow-Tools von verschiedenen Anbietern für Ihr Krankenhaus nutzen können.
                            Dabei werden die Tools nicht nur zentral angeboten und bereitgestellt, sondern über unser innovatives Datenmodell miteinander vernetzt, so dass redundante Datenbearbeitungen entfallen.
                        </p>

                        <h3 className="pt-4">Was für einen Nutzen habe ich als HYAPP Kunde?</h3>
                        <p>
                            Sie stellen sich eine Auswahl der besten auf dem Markt verfügbaren Controlling-Tools individuell zusammen und können diese zentral für Ihr Klinikmanagement nutzen.
                            Neben der vereinfachten Datenbearbeitung erhalten Sie durch unseren umfangreichen Datenpool zudem Zugriff auf einen umfassenden Benchmark sowie Freemium-Tools.
                        </p>

                        <h3 className="pt-4">Warum sollte ich HYAPP nutzen?</h3>
                        <p>
                            Sie sollten HYAPP nutzen, wenn Sie unnötige Datenverarbeitungs-Schritte reduzieren, Zeit und Ressourcen sparen und Mehrwert durch neueste Tools und Analyse-Software für Ihr Klinikmanagement generieren wollen.
                        </p>

                        <h3 className="pt-4">Benötige ich eine bestimmte Software</h3>
                        <p>
                            Alles was Sie brauchen ist ein aktueller Browser (Google Chrome, Firefox) und die gängigen MS Office Anwendungen.
                        </p>

                        <h3 className="pt-4">Welche Voraussetzungen müssen gegeben sein?</h3>
                        <p>
                            Sie sollten als Vertreter Ihres Krankenhauses kaufberechtigt sein bzw. die Freigabe der Geschäftsführung sollte vorliegen.
                        </p>

                        <h3 className="pt-4">Wie lange kann ich die Apps nutzen?</h3>
                        <p>
                            Die ausgewählten Apps stehen Ihnen je nach Vertragsgestaltung unbegrenzt bis zur Kündigung zur Verfügung.
                        </p>

                        <h3 className="pt-4">Können die Apps veralten?</h3>
                        <p>
                            Alle Partner der HYAPP stellen sicher, dass die angebotenen Apps dem neuesten Stand entsprechen und regelmäßig aktualisiert werden.
                            Über Software-Aktualisierungen werden Sie per E-Mail informiert.
                            Cloud-basierte Apps aktualisieren sich automatisch.
                        </p>

                        <h3 className="pt-4">Muss ich mich für jede App extra anmelden?</h3>
                        <p>
                            HYAPP nutzt ein Single Sign-On Verfahren.
                            Somit können Sie, mit einem Konto, auf alle erworbenen Apps auf HYAPP zugreifen.
                        </p>

                        <h3 className="pt-4">Gibt es eine Laufzeit/Vertragsbindung?</h3>
                        <p>
                            Die Laufzeit beträgt ein Jahr und verlängert sich automatisch um ein weiteres Jahr, sofern nicht innerhalb der 3 monatigen Frist eine Kündigung erfolgt.
                        </p>

                        <h3 className="pt-4">Wo finde ich Hilfe?</h3>
                        <p>
                            Auf der Plattform gibt es eine <Link href="/contact"><a className="text-secondary"><u>Kontaktseite</u></a></Link>, über die Sie bei allgemeinen Fragen Unterstützung finden.
                            Bei App-spezifischen Fragen können Sie auf der jeweiligen App-Seite direkt mit dem App-Anbieter in Kontakt treten.
                        </p>

                        <h3 className="pt-4">Wie schnell bekommt man Analyseergebnisse von einzelnen Anwendungen?</h3>
                        <p>
                            Die Analysen laufen überwiegend in Echtzeit und sind abhängig von der jeweiligen App.
                            Bei Verwendung der App wird über eine Skala der berechnete Zeitaufwand angezeigt.
                        </p>

                        <h3 className="pt-4">Wie kann ich Fragen zu meinen Analyseergebnissen platzieren und Unterstützung bei der Interpretation erhalten?</h3>
                        <p>
                            Bei Fragen zu Analyseergebnissen können Sie sich über die Chat-Funktion an einen unserer erfahrenen Berater wenden, der sie ach gerne mit weiteren Experten vernetzt.
                        </p>

                        <h3 className="pt-4">Wo kann ich eigene Vorschläge und Ideen zu neuen Analysetools und Verknüpfungen von Datenstrukturen machen?</h3>
                        <p>
                            Wir freuen uns über Anregungen, Verbesserungen und Feedback über die <Link href="/contact"><a className="text-secondary"><u>Kontaktseite</u></a></Link> und setzen uns dann zeitnah mit Ihnen in Verbindung.
                        </p>

                        <h3 className="pt-4">Wie kann man einen Berater buchen?</h3>
                        <p>
                            Wir verfügen über ein großes Netzwerk an erfahrenen Beratern mit langjähriger Expertise im Krankenhausmanagement.
                            Schreiben Sie uns gerne an über die <Link href="/contact"><a className="text-secondary"><u>Kontaktseite</u></a></Link> und wir melden uns bei Ihnen.
                        </p>

                        <h3 className="pt-4">Welche Daten brauche ich für die Apps?</h3>
                        <p>
                            Die für die jeweilige App erforderlichen Daten können Sie der App-Detailseite entnehmen.
                            Bei Kauf einer App wird diese detailliert beschrieben.
                        </p>
                    </div>
                </div>
            </div>
        </Layout >
    )
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            ...await serverSideTranslations(locale, ['common', 'menu'])
        }
    }
}
